import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://albldmiocxrhxsdenvom.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFsYmxkbWlvY3hyaHhzZGVudm9tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ0ODUzMjEsImV4cCI6MjA3MDA2MTMyMX0.H4KvmgNrrobyuTDsWNroa5R38AVVJVp-ilR6-m23xYE';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
